import React, { useState } from 'react';
import db from '../data/db.json';
import './Contact.css';

const Contact = () => {
  const { title, subtitle, form, info } = db.contact;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send the data to a server
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <div className="contact">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">{title}</h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">{form.name.label}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={form.name.placeholder}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">{form.email.label}</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={form.email.placeholder}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">{form.phone.label}</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder={form.phone.placeholder}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">{form.message.label}</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={form.message.placeholder}
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary">
                  {form.submit}
                </button>
              </form>
            </div>

            <div className="contact-info-section">
              <h2>{info.title}</h2>
              <p className="info-description">{info.description}</p>
              
              <div className="contact-details">
                <div className="contact-detail-item">
                  <strong>Address:</strong>
                  <p>{db.site.contact.address}</p>
                </div>
                
                <div className="contact-detail-item">
                  <strong>Phone:</strong>
                  <p><a href={`tel:${db.site.contact.phone}`}>{db.site.contact.phone}</a></p>
                </div>
                
                <div className="contact-detail-item">
                  <strong>Email:</strong>
                  <p><a href={`mailto:${db.site.contact.email}`}>{db.site.contact.email}</a></p>
                </div>
                
                <div className="contact-detail-item">
                  <strong>Hours:</strong>
                  <p>{db.site.contact.hours}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

